import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import {ACTION, STATUS} from '../constant';

@Injectable()
export class ParticipationFormCodeResolve implements Resolve<Observable<any>> {

  surveyFormCode$: Observable<any>;

  constructor(private store: Store<any>) {
    this.surveyFormCode$ = this.store.select('CAMPUS_REDUCER');
  }

  resolve(route: ActivatedRouteSnapshot): any {
    this.store.dispatch({
      type: ACTION.LOAD_FORM_CODE,
      payload: {}
    });

    return this.surveyFormCode$
      .filter(state => state.status === STATUS.COMPLETED)
      .map(state => state.data.surveyForm.formCode)
      .first();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/resolves/participation-form-code.resolve.ts